export const SET_SOLUTIONS_LIST = 'solutions/SET_SOLUTIONS_LIST'
export const SET_MANAGE_SOLUTION = 'solutions/SET_MANAGE_SOLUTION'
export const UPDATE_ACTIVE_SOLUTION = 'solutions/UPDATE_ACTIVE_SOLUTION'
export const SET_PAGINATION = 'solutions/SET_PAGINATION'
export const RESET_PAGINATION = 'solutions/RESET_PAGINATION'
